"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var FlexibleBar_1 = __importDefault(require("./widgets/DeviceStatistics/FlexibleBar"));
var DeviceLegend_1 = __importDefault(require("./widgets/DeviceStatistics/DeviceLegend"));
var BaseStatisticsLayout_1 = __importDefault(require("./BaseStatisticsLayout"));
/**
 * Calculate a percentage with rounded one dp.
 *
 * @param count The count of the portion.
 * @param total The sum of all counts in all portions.
 */
function getFormattedPercent(count, total) {
    var percent = (count * 100) / total;
    return Math.round(percent * 10) / 10;
}
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    var _a, _b;
    return ({
        devicesRoot: {
            display: 'flex',
            height: 30,
            borderRadius: 30,
            width: '100%',
            overflow: 'hidden',
            marginBottom: 20,
        },
        legendRoot: (_a = {
                display: 'flex',
                justifyContent: 'space-between'
            },
            _a[theme.breakpoints.up('sm')] = {
                justifyContent: 'unset',
            },
            _a),
        legend: (_b = {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            },
            _b[theme.breakpoints.up('sm')] = {
                marginRight: 40,
                alignItems: 'unset',
                '&:last-child': {
                    marginRight: 0,
                },
            },
            _b),
    });
});
function DeviceStatistics(_a) {
    var deviceClicks = _a.deviceClicks;
    var theme = (0, styles_1.useTheme)();
    var classes = useStyles();
    /**
     * Process device clicks data by adding in labels and relevant color codes.
     *
     * @param data The device clicks data to be processed.
     */
    function processStatistics(data) {
        return [
            {
                label: 'Desktop',
                count: data.desktop,
                color: theme.palette.primary.dark,
            },
            {
                label: 'Tablet',
                count: data.tablet,
                color: theme.palette.secondary.main,
            },
            {
                label: 'Mobile',
                count: data.mobile,
                color: theme.palette.secondary.light,
            },
            {
                label: 'Others',
                count: data.others,
                color: theme.palette.background.default,
            },
        ];
    }
    var processedDeviceClicks = processStatistics(deviceClicks);
    var totalClicks = processedDeviceClicks
        .map(function (clicks) { return clicks.count; })
        .reduce(function (x, y) { return x + y; }, 0);
    return (react_1.default.createElement(BaseStatisticsLayout_1.default, { title: "What devices are your users on?" },
        react_1.default.createElement("div", { className: classes.devicesRoot }, processedDeviceClicks.map(function (clicks) { return (react_1.default.createElement(FlexibleBar_1.default, { label: clicks.label, count: clicks.count, color: clicks.color })); })),
        react_1.default.createElement("div", { className: classes.legendRoot }, processedDeviceClicks.map(function (clicks) {
            var percent = getFormattedPercent(clicks.count, totalClicks);
            return (react_1.default.createElement(DeviceLegend_1.default, { key: clicks.label, className: classes.legend, percent: percent, dotColor: clicks.color, label: clicks.label }));
        }))));
}
exports.default = DeviceStatistics;
